<template>
  <div class="row">
    <div class="col-sm-12">
      <h4 class="card-title">Bildirimler</h4>
    </div>
    <div class="col-sm-12" v-for="(data,index) in notificationData" :key="index">
      <iq-card>
        <template v-slot:body>
            <ul class="notification-list m-0 p-0">
              <li class="d-flex align-items-center justify-content-between">
                  <div class="user-img img-fluid"><img :src="data.img" alt="story-img" class="rounded-circle avatar-40"></div>
                  <div class="w-100">
                    <div class="d-flex justify-content-between">
                        <div class=" ms-3">
                          <h6>{{data.heading}}</h6>
                          <p class="mb-0">{{data.time}}</p>
                        </div>
                        <div class="d-flex align-items-center">
                          <a href="javascript:void();" :class="data.iconbg"><i :class="data.icon"></i></a>
                          <div class="card-header-toolbar d-flex align-items-center">
                              <div class="dropdown">
                                <span class="dropdown-toggle" data-bs-toggle="dropdown">
                                <i class="ri-more-fill h4"></i>
                                </span>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a class="dropdown-item" href="#" v-for="(data,index) in action" :key="index">
                                      <i :class="data.icon"></i>{{data.title}}</a>
                                </div>
                              </div>
                          </div>
                        </div>
                    </div>
                  </div>
              </li>
            </ul>
        </template>
      </iq-card>
    </div>
  </div>
</template>
<script>
// import { socialvue } from '../../../config/pluginInit'

export default {
  name: 'Notification',
  mounted () {
    // socialvue.index()
  },
  data () {
    return {
      seen: true,
      notificationData: [
        {
          img: require('../../../assets/images/user/01.jpg'),
          heading: 'Deneme',
          time: '30 dk önce',
          icon: 'ri-award-line',
          iconbg: 'me-3 iq-notify bg-soft-primary rounded'
        },
        {
          img: require('../../../assets/images/user/01.jpg'),
          heading: 'Deneme',
          time: '30 dk önce',
          icon: 'ri-award-line',
          iconbg: 'me-3 iq-notify bg-soft-primary rounded'
        },
        {
          img: require('../../../assets/images/user/01.jpg'),
          heading: 'Deneme',
          time: '30 dk önce',
          icon: 'ri-award-line',
          iconbg: 'me-3 iq-notify bg-soft-primary rounded'
        }
      ],
      action: [
        {
          icon: 'ri-eye-fill me-2',
          title: 'Gör'
        },
        {
          icon: 'ri-delete-bin-6-fill me-2',
          title: 'Sil'
        }
        // {
        //   icon: 'ri-pencil-fill me-2',
        //   title: 'Edit'
        // },
        // {
        //   icon: 'ri-printer-fill me-2',
        //   title: 'Print'
        // },
        // {
        //   icon: 'ri-file-download-fill me-2',
        //   title: 'Download'
        // }
      ]
    }
  }
}
</script>
